import { QIcon_close_default } from '@repo/icons/index'

export interface SidePopupHeaderProps {
  title: string | JSX.Element
  onClose: () => void
  SubIcon?: any
  onClickSubIcon?: any
  headerRef?: any
}

const Header = ({ title, onClose, SubIcon, headerRef }: SidePopupHeaderProps) => {
  return (
    <div
      className="z-9999 fixed top-0 left-0 flex w-full flex-row items-center justify-between border-b-[1px] border-gray-200 bg-white px-[20px] py-[16px]"
      ref={headerRef}
    >
      <div className="flex-wrap font-bold">{title}</div>
      <div className="flex flex-row items-center justify-end">
        {SubIcon && <SubIcon width={24} height={24} className="cursor-pointer" />}
        <QIcon_close_default width={24} height={24} className="ml-[24px] cursor-pointer" onClick={onClose} />
      </div>
    </div>
  )
}

export default Header
